export { MorphemeInfoPanelDictionaryTab } from "#morpheme-info-panel-dictionary-tab";
export { useMorphemeInfoPanelDictionaryGraphemeSections } from "#use-morpheme-info-panel-dictionary-grapheme-sections";
